module.exports = __webpack_public_path__ + "img/yin-yang.daf6875e.svg";